import React from 'react';

import { images } from '../../constants'

const SubHeading = ({title}) => (
  <div style={ {marginBottom: '1rem'}} className='text-center flex flex-col justify-center place-items-center'>
    <p className="p__cormorant text-yellow-200">
      {title}
    </p>

    <img src={images.spoon} alt="spoon" className='spoon__img' />
  </div>
);

export default SubHeading;
